import { render } from "./TravelSausage.vue?vue&type=template&id=003c354d&scoped=true"
import script from "./TravelSausage.vue?vue&type=script&lang=js"
export * from "./TravelSausage.vue?vue&type=script&lang=js"

import "./TravelSausage.vue?vue&type=style&index=0&id=003c354d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-003c354d"]])

export default __exports__